import { GameServer, Nft } from 'models';

export const isUnassignedNft = (gameServers: GameServer[], nft: Nft): boolean =>
  gameServers?.every(
    (gameServer: GameServer) =>
      !gameServer?.stats?.wallet_stats?.assigned_nfts?.includes(nft.edition)
  );
